import { hasData } from "data/DataStore";

const LOADING_MSG = "Checking catalog...";
const NO_AVAIL_MSG = "No copies available";

/**
 * Returns the appropriate button state.
 * @param {boolean} loading If the component is loading or not.
 * @param {boolean} error If there is an error or not.
 * @param {[object]} data total copies available of a title in all formats.
 */
export function getButtonState(loading, data) {
    let button = {};

	if (loading) {
        button.text = LOADING_MSG;
        button.disabled = true;
	} else if (hasData(data)) {
        let held = getKeyCount(data,"total");
        let available = getKeyCount(data,"available");
        
        if (held) {
            button.text = getButtonText(held, available);
            button.disabled = false;
        } else return null;
    } else {
        return null;
    }

	return button;
}

/**
 * Generate the text for button based on OTS availability data.
 *
 * @param {[object]} otsData total copies available of a title in all formats.
 */
export function getButtonText(held, available) {
    let text = "";

    if (available === 0 && held !== 0) {
        text = NO_AVAIL_MSG;
    } else if (available === 1) {
        text = `${numberDisplay(available)} copy available`;
    } else if (available >= 1) {
        text = `${numberDisplay(available)} copies available`;
    }

    return text;
}

/**
 * Given an array of objects, gets the total count of the passed in key
 * Example: arr = [{available:1, totalHeld:2}, {available:4, totalHeld: 5}], getKeyCount(arr, available) would return 5.
 * @param {[]} arr Array with key-value pair objects
 * @param {string} key Name of the key for which we get the total count
 */
function getKeyCount(arr, key) {
    return arr.reduce((sum, row) => sum + row[key], 0)
}

/**
 * Generate the text for availability of a title in a given format.
 * @param {string} format the format. Print, Audio, etc.
 * @param {int} available count of available copies.
 * @param {int} totalHeld total copies owned by the library
 */
export function getFormatAvailabilityText(format, available, totalHeld) {
    return `${format} (${numberDisplay(available)} of ${numberDisplay(totalHeld)})`;
}
/**
 * numbers greater than 99 are mutated to 99+
 *
 * @param {int} the number.
 */
function numberDisplay(num){
    return num > 99 ? "99+" : num;
}



// WEBPACK FOOTER //
// ./src/react/views/ots/OtsViewFunctions.js